import React from 'react';
import { Grid, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const Footer = () => (
  <footer>
    <Grid>
      <Row>
        <Col sm={6} md={6}>

          <div className="qoute">
            <p>
              “Learn the rules like a pro,
              <br />
              so you can break them like an artist.”
            </p>
            <strong>-Pablo Picasso</strong>
          </div>

        </Col>
        <Col sm={3} md={3}>

          <h5>Quick Links</h5>
          <ul>
            <li><Link to="/our-story">About WineXRay</Link></li>
            <li><Link to="/client-login">Client Center Login</Link></li>
            <li><Link to="/contact-us">Contact Us</Link></li>
          </ul>

        </Col>
        <Col sm={3} md={3}>

          <h5>Address</h5>
          <address>
            <p>303 Gateway Road West Suite B</p>
            <p>Napa, California 94558</p>
            <p>+1 (707) 252-9692</p>
            <a href="mailto:info@winexray.com">info@winexray.com</a>
          </address>

        </Col>
        <Col sm={12}>
          <p className="copyright">
            © Copyright 2010-{new Date().getFullYear()}. WINEXRAY LLC
          </p>
        </Col>
      </Row>
    </Grid>
  </footer>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/components/ui/Footer.js